import { IAction } from '@Root/types'

export const SubscriptionsActionTypes = {
  CANCEL_SUBSCRIPTION: '@@subscription/CANCEL_SUBSCRIPTION',
  CANCEL_SUBSCRIPTION_SUCCESS: '@@subscription/CANCEL_SUBSCRIPTION_SUCCESS',
  CANCEL_SUBSCRIPTION_FAILURE: '@@subscription/CANCEL_SUBSCRIPTION_FAILURE',

  UPDATE_SUBSCRIPTION: '@@subscription/UPDATE_SUBSCRIPTION',
  UPDATE_SUBSCRIPTION_SUCCESS: '@@subscription/UPDATE_SUBSCRIPTION_SUCCESS',
  UPDATE_SUBSCRIPTION_FAILURE: '@@subscription/UPDATE_SUBSCRIPTION_FAILURE',

  START_CHECKOUT_SESSION: '@@subscription/START_CHECKOUT_SESSION',
  START_CHECKOUT_SESSION_FAILURE: '@@subscription/START_CHECKOUT_SESSION_FAILURE',
}

export interface ISubscription {
  readonly id: number
  readonly attributes: ISubscriptionAttributes
}

export interface ISubscriptionData {
  readonly id: string
  readonly type: 'subscription',
  readonly attributes: ISubscriptionAttributes
}

interface ISubscriptionAttributes {
  readonly plan: string
  readonly maxLanguagesLimit: number
  readonly maxSpeakerVoicesLimit: number
  readonly subtitlingMinutesProvided: number
  readonly subtitlingMinutesProvidedByPeriod: number
  readonly isCurrent: boolean
  readonly isCanceled: boolean
  readonly isTrialing: boolean
  readonly cancelAtPeriodEnd: boolean
  readonly hasCreditLikeCharging: boolean
  readonly renewalDate: string
  readonly allowsVoice: boolean
  readonly allowsVoiceCloning: boolean
  readonly allowsTranslationAdaptionForDubbing: boolean
  readonly allowsLipSyncing: boolean
  readonly isPaymentProcessing: boolean
}

export interface ISubscriptionReference {
  readonly id: string
  readonly type: 'subscription'
}

export interface ICancelSubscriptionPayload {
  readonly accountId: number
  readonly cancellationReason?: string
}

export interface IStartCheckoutSessionPayload {
  readonly accountId: number
  readonly planName: string
  readonly currency: string
}

export interface IUpdateSubscriptionPayload {
  readonly subscriptionId: number
  readonly planName: string
}

export interface IUpdateSubscriptionSuccessResponseBody {
  readonly data: ISubscriptionData
}

export type ICancelSubscriptionSuccessResponseBody = IUpdateSubscriptionSuccessResponseBody

export type TSubscriptionsActionTypes =
  IAction<ISubscription>
